import PropTypes from 'prop-types';

export default {
	reasonDdlLabel: PropTypes.string,
	invalidFormMsg: PropTypes.string,
	dataToReview: PropTypes.string,
	dateFormat: PropTypes.string,
	fromLabel: PropTypes.string,
	toLabel: PropTypes.string,
	amtLabel: PropTypes.string,
	templateAmtLabel: PropTypes.string,
	refLabel: PropTypes.string,
	templateRefLabel: PropTypes.string,
	dateLabel: PropTypes.string,
	balAfterLabel: PropTypes.string,
	typeLabel: PropTypes.string,
	startDateLabel: PropTypes.string,
	endDateLabel: PropTypes.string,
	repeatingTypeLabel: PropTypes.string,
	timesLabel: PropTypes.string,
	reasonLabel: PropTypes.string,
	reviewPageHeading: PropTypes.string,
	reviewPageSubHeading: PropTypes.string,
	reviewToPayment: PropTypes.string,
	continueText: PropTypes.string,
	acknowledgement: PropTypes.shape({
		pageHeading: PropTypes.string,
		pageSubHeading: PropTypes.string,
		bulletPointsHeader: PropTypes.string,
		importantWarningDescription: PropTypes.string,
		helpMeText: PropTypes.string,
	}),
	safePayment: PropTypes.shape({
		pageHeading: PropTypes.string,
		pageSubheading: PropTypes.string,
		spotScamText: PropTypes.string,
		protectYourselfText: PropTypes.string,
		scammedHeading: PropTypes.string,
		scammedSubheading: PropTypes.string,
		fraudAwarenessCentreText: PropTypes.string,
		errorText: PropTypes.string,
		declaration: PropTypes.string,
	}),
	cancelledPayment: PropTypes.shape({
		pageHeading: PropTypes.string,
		pageSubheading: PropTypes.string,
		suspectFraudHeding: PropTypes.string,
		suspectFraudSubheading: PropTypes.string,
		suspectFraudLink1: PropTypes.string,
		suspectFraudLink2: PropTypes.string,
		suspectFraudLink3: PropTypes.string,
	}),
};
